<template>
  <div v-if="!readonly">
    <el-form ref="formRef" :model="order" label-position="top" require-asterisk-position="right">
      <!-- Selects -->
      <div class="col">
        <div v-if="!isMCover" class="row">
          <el-form-item prop="bodySide" :label="$t('views.customize.workflow.form.bodySide')">
            <div class="side-button-group">
              <button-card-config
                v-for="side in Object.values(BodySide).filter(side => side !== BodySide.none)"
                :key="side"
                :title="$t(`enum.bodySide.${side}`)"
                @click="emitBodySideSelected(side)"
                class="card-custom"
                :class="{ active: order.bodySide === side }"
              >
                <img 
                  :src="getSideImage(side)" 
                  :alt="$t(`enum.bodySide.${side}`)" 
                  class="side-image" />
              </button-card-config>
            </div>
          </el-form-item>
        </div>

        <div v-if="product?.name?.toLowerCase().includes('oberschenkel') || product?.name?.toLowerCase().includes('c-flex')" class="row">
          <el-form-item
            prop="kneeJoint"
            :label="$t('views.customize.workflow.form.kneeJoint')"
            :rules="{
              required: true,
              message: $t('error.vuelidate.required'),
              trigger: 'blur',
            }"
          >
            <el-select
              v-if="product.name?.toLowerCase().includes('s-cover')"
              id="knee-joint"
              v-model="order.kneeJoint"
              :placeholder="$t('views.configurator.pleaseSelect')"
            >
              <el-option v-for="option in kneeJointOptionsCoverTypeS" :key="option" :label="option" :value="option" />
            </el-select>

            <el-select v-else id="knee-joint" v-model="order.kneeJoint" :placeholder="$t('views.configurator.pleaseSelect')">
              <el-option v-for="option in kneeJointOptionsDefault" :key="option" :label="option" :value="option" />
            </el-select>
          </el-form-item>
        </div>
        <div v-if="isMCover" class="row">
          <el-form-item
            prop="kneeJoint"
            :label="$t('views.customize.workflow.form.kneeJoint')"
            :rules="{
              required: true,
              message: $t('error.vuelidate.required'),
              trigger: 'blur',
            }"
          >
            <el-select id="knee-joint" v-model="order.kneeJoint" :placeholder="$t('views.configurator.pleaseSelect')">
              <el-option v-for="option in kneeJointOptionsDefault" :key="option" :label="option" :value="option" />
            </el-select>
          </el-form-item>
        </div>
      </div>

      <!-- Label and Switch for beidseitig amputiert (bilateral amputee) -->
      <!--       <div v-if="isLuttermannDomain || isGzPilzDomain || isWJTOrthoDomain || isAidddoDomain || isCekoonDomain || isDemoDomain" class="row">
        <div class="col mb-3">
          <el-form-item 
            prop="bilateralAmputee" 
            :label="$t('components.order-summary.bilateralAmputee')"
          >
            <el-switch
              id="bilateralAmputee"
              v-model="order.bilateralAmputee"
              active-text=""
              inactive-text=""
              :active-value="true"
              :inactive-value="false"
              class="custom-switch"
            />
          </el-form-item>
        </div>
      </div> -->

      <!-- <div class="row">
        <div class="col mb-3" v-if="this.showZipperOption &&  (product?.name?.toLowerCase().includes('u-flex') || product?.name?.toLowerCase().includes('c-flex'))">
          <label for="zip" class="form-label">{{ $t('views.customize.workflow.form.zip') }}</label> <br />
          <el-radio-group v-model="order.zip">
            <el-radio-button
              v-for="zip in Object.values(ZipType)"
              :key="zip"
              :label="zip"
              id="zip"
              @change="$emit('zipChanged', zip)"
            >
              {{ $t(`enum.zipType.${zip}`) }}
            </el-radio-button>
          </el-radio-group>
        </div>
        <div class="col mb-3" v-show="order.zip != 'no'" v-if="this.showZipperOption &&  (product?.name?.toLowerCase().includes('u-flex') || product?.name?.toLowerCase().includes('c-flex'))">
          <label for="sew-in-by-customer" class="form-label">{{ $t('views.customize.workflow.form.sewInByCustomer') }}</label>
          <br />
          <el-switch
            v-model="order.sewInByCustomer"
            id="sew-in-by-customer"
            @change="$emit('zipChanged', order.zip)"
          />
        </div>
        <div class="col mb-3">
        </div>
      </div> -->
      <!-- <div class="row" v-if="!product?.name?.toLowerCase().includes('s-cover')">
        <label for="cosmetic-ending-at-foot" class="form-label">{{ $t('views.customize.workflow.form.cosmeticEndingAtFoot') }}</label>
        <br />
        <el-switch
          v-model="order.cosmeticEndingAtFoot"
          id="cosmetic-ending-at-foot"
        />
      </div> -->
      <!-- <div class="row" v-if="!product?.name?.toLowerCase().includes('s-cover')">
        <div class="col mb-3">
          <label for="automatic-fit" class="form-label">{{ $t('views.customize.workflow.form.automaticFit') }}</label>
          <br />
          <el-switch
            id="automatic-fit"
            v-model="automaticFit"
            @change="automaticFitChanged()"
            :disabled="product.type.name.toLowerCase() == 'covers'"
          />
        </div>
      </div> -->
      <!-- Progress bars -->
      <div v-if="automaticFit">
        <div class="row">
          <div v-loading="bodyAttributes.length <= 0 && authentication.isAuthenticated" class="col" element-loading-background="rgba(122, 122, 122, 0)">
            <el-form-item prop="scanFiles" :label="$t('views.customize.workflow.form.scanFiles')">
              <select id="scan" v-model="selectedBodyAttribute" class="form-select" @change="$emit('scanFileChanged', selectedBodyAttribute)">
                <option :value="null" :label="$t(`components.product-parameter.scan.none`)" />
                <option
                  v-for="bodyAttribute in bodyAttributes"
                  :key="bodyAttribute.characteristicId"
                  :value="bodyAttribute"
                  :label="$t(`components.product-parameter.scan.${bodyAttribute.bodyPart?.name}`) + ' - ' + bodyAttribute.scanFile?.name"
                />
              </select>
            </el-form-item>
          </div>
        </div>
      </div>
      <div v-if="!isMCover">
        <div class="row mt-1">
          <div v-if="!product?.name?.toLowerCase().includes('s-cover')" class="col">
            <el-form-item prop="heightWithoutDeduction">
              <div class="col">
                <label for="height-range" class="el-form-item__label mb-0"
                  >{{ $t('components.order-form.height') }}
                  <a class="info-button" @click="$emit('infoButtonClicked', 'content2')"
                    ><el-icon :size="15" style="position: relative; left: 2px; top: 3px"><InfoFilled /></el-icon
                  ></a>
                </label>
                <el-slider id="height-range" v-model="order.heightWithoutDeduction" :min="200" :max="550" />
                <el-input-number v-model="order.heightWithoutDeduction" />
              </div>
            </el-form-item>
          </div>
        </div>

        <div class="row mt-1">
          <div v-if="!product?.name?.toLowerCase().includes('s-cover')" class="col">
            <el-form-item prop="depth">
              <div class="col">
                <label for="width-range" class="el-form-label__label mb-0">
                  {{ $t('components.order-form.scope-top') }}
                  <a class="info-button" @click="$emit('infoButtonClicked', 'content1')">
                    <el-icon :size="15" style="position: relative; left: 2px; top: 3px"><InfoFilled /></el-icon>
                  </a>
                </label>
                <br />
                <el-slider id="width-range" v-model="order.depth" :min="150" :max="430" />
                <el-input-number v-model="order.depth" />
              </div>
            </el-form-item>
          </div>
        </div>
        

        <div class="row mt-1">
          <div v-if="!product?.name?.toLowerCase().includes('s-cover')" class="col">
            <el-form-item prop="calfCircumferenceWithoutDeduction">
              <div class="col">
                <label for="lower-range" class="el-form-item__label mb-0"
                  >{{ $t('components.order-form.scope-bottom') }}
                  <a class="info-button" @click="$emit('infoButtonClicked', 'content3')"
                    ><el-icon :size="15" style="position: relative; left: 2px; top: 3px"><InfoFilled /></el-icon
                  ></a>
                </label>
                <el-slider id="lower-range" v-model="order.calfCircumferenceWithoutDeduction" :min="100" :max="460" />
                <el-input-number v-model="order.calfCircumferenceWithoutDeduction"/>
              </div>
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
  </div>
  <div v-else>
    <div class="row1">
      <label class="col-sm-6 form-label text-secondary" for="body-side-readonly">{{ $t('views.customize.workflow.form.bodySide') }}</label>
      <label class="col-sm-6 form-label">{{ $t(`enum.bodySide.${order?.bodySide}`) }}</label>
    </div>
    <div class="row1">
      <label class="col-sm-6 form-label text-secondary">{{ $t('views.customize.workflow.form.kneeJoint') }}</label>
      <label class="col-sm-6 form-label">{{ order?.kneeJoint }}</label>
    </div>
    <!-- <div class="row1"  v-if="!product?.name?.toLowerCase().includes('s-cover')">
      <label class="col-sm-6 form-label text-secondary">{{ $t('views.customize.workflow.form.foot') }}</label>
      <label class="col-sm-6 form-label">{{ order?.foot }}</label>
    </div> -->
    <!-- <div class="row1" v-if="!authenticator.domains.some(d => d.urlSuffix == 'wjtortho') && product?.name?.toLowerCase().includes('u-flex') || product?.name?.toLowerCase().includes('c-flex')">
      <label class="col-sm-6 form-label text-secondary">{{ $t('views.customize.workflow.form.zip') }}</label>
      <label class="col-sm-6 form-label">{{ $t(`enum.zipType.${order?.zip}`) }}</label>
    </div> -->
    <!-- <div class="row1" v-if="!authenticator.domains.some(d => d.urlSuffix == 'wjtortho') && product?.name?.toLowerCase().includes('u-flex') || product?.name?.toLowerCase().includes('c-flex')">
      <label class="col-sm-6 form-label text-secondary">{{ $t('views.customize.workflow.form.sewInByCustomer') }}</label>
      <label class="col-sm-6 form-label">{{ $t(`enum.yesNoType.${order?.sewInByCustomer}`) }}</label>
    </div> -->
    <!-- <div class="row1">
      <label class="col-sm-6 form-label text-secondary">{{ $t('views.customize.workflow.form.cosmeticEndingAtFoot') }}</label>
      <label class="col-sm-6 form-label">{{ $t(`enum.yesNoType.${order?.cosmeticEndingAtFoot}`) }}</label>
    </div> -->
    <div v-if="!automaticFit">
      <div v-if="!product?.name?.toLowerCase().includes('s-cover')" class="row1">
        <label class="col-sm-6 form-label text-secondary">{{ $t('components.order-form.scope-top') }}</label>
        <label class="col-sm-6 form-label">{{ order?.depth }}</label>
      </div>
      <div v-if="!product?.name?.toLowerCase().includes('s-cover')" class="row1">
        <label class="col-sm-6 form-label text-secondary">{{ $t('components.order-form.height') }}</label>
        <label class="col-sm-6 form-label">{{ order?.heightWithoutDeduction }}</label>
      </div>
      <div v-if="!product?.name?.toLowerCase().includes('s-cover')" class="row1">
        <label class="col-sm-6 form-label text-secondary">{{ $t('components.order-form.scope-bottom') }}</label>
        <label class="col-sm-6 form-label">{{ order?.calfCircumferenceWithoutDeduction }}</label>
      </div>
    </div>
    <div v-else>
      <div v-if="!product?.name?.toLowerCase().includes('s-cover')" class="row1">
        <label class="col-sm-6 form-label text-secondary">{{ $t('views.customize.workflow.form.scanFiles') }}</label>
        <label class="col-sm-6 form-label">{{ selectedBodyAttribute }}</label>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Ref } from 'vue-facing-decorator';

import { BodySide, ZipType } from '@/types/enum/order';
import * as CustomerService from '@/services/api/customerService';
import Auth from '@/services/api/auth';
import { Body_Attribute } from '@/types/api/Patient/BodyAttribute';
import { Product } from '@/types/api/Model/Product';
import { ElForm } from 'element-plus';
import { OrderRequestData } from '@/services/api/orderService';
import ButtonCardConfig from '@/components/layout/ButtonCardConfig.vue';
import RightImage from "@/assets/images/menu/bodySide/Right.png"
import LeftImage from "@/assets/images/menu/bodySide/Left.png"
import BiliteralImage from "@/assets/images/menu/bodySide/Bilateral.png"
import { useUserStore } from '@/stores/userStore';



@Component({
  components: {
    ButtonCardConfig
  },
  emits: ['scanFileChanged', 'zipChanged', 'infoButtonClicked', 'isValid'],
})

export default class ProductParameterCover extends Vue {
  @Prop() order!: OrderRequestData;
  @Prop() product!: Product;
  @Prop({ default: false }) readonly!: boolean;

  authentication = Auth.getInstance();
  userStore = useUserStore();


  @Ref('formRef') formRef!: InstanceType<typeof ElForm>;

  async validateForm(): Promise<boolean> {
    if (!this.formRef) {
      return false;
    }

    try {
      const valid = await this.formRef.validate();
      this.$emit('isValid', valid);
      return valid;
    } catch (error) {
      console.warn('Form validation error:', error);
      return false;
    }
  }
  emitBodySideSelected(side: any){
    this.order.bodySide = side;
  }
  getSideImage(side: BodySide): string {
    switch (side) {
      case BodySide.right:
        return RightImage;
      case BodySide.left:
        return LeftImage;
      case BodySide.bilateral:
        return BiliteralImage;
      default:
        return RightImage;
    }
  }
  get isLuttermannDomain() {
    return this.userStore.domain?.urlSuffix === 'luttermann';
  }

  get isGzPilzDomain() {
    return this.userStore.domain?.urlSuffix === 'gzpilz';
  }

  get isWJTOrthoDomain() {
    return this.userStore.domain?.urlSuffix === 'wjtortho';
  }

  get isAidddoDomain() {
    return this.userStore.domain?.urlSuffix === 'aidddo';
  }

  get isDemoDomain() {
    return this.userStore.domain?.urlSuffix === 'demo';
  }

  get isCekoonDomain() {
    return this.userStore.domain?.urlSuffix === 'cekoon';
  }

  get isMCover() {
    return this.product?.name.toLowerCase().includes('m-cover');
  }

  bodyAttributes: Body_Attribute[] = [];

  BodySide = BodySide;
  ZipType = ZipType;
  selectedBodyAttribute: Body_Attribute | null = null;

  automaticFit = false;

  hideZipperCompanyNames: string[] = ['wjtortho'];
  showZipperOption = true;

  kneeOption = 'Andere';

  kneeJointOptionsCoverTypeS: string[] = [
    '3R60',
    '3R80',
    '3WR95 Aqua Knie',
    'Andere',
    'Balance Knie OFM1',
    'Balance Knie OFM2',
    'C-Leg',
    'Genium',
    'Genium X3',
    'Gepardenknie',
    'Kneuro',
    'Kenevo',
    'Mauch Knie',
    'Mauch Knie Plus',
    'Paso Knie',
    'Rheo Knee XC',
    'Rheo Knie',
    'Total Knee 2000',
    'Total Knee 2100',
    'Totales Knie 1900',
    'Quadro',
    'Allux',
    'Genium X4',
    'Varia Flex',
    'Very Good',
    'Hytrek',
    'Locking Knee',
  ];

  kneeJointOptionsDefault: string[] = [
    '3R60',
    '3R80',
    '3WR95 Aqua Knie',
    'Andere',
    'Balance Knie OFM1',
    'Balance Knie OFM2',
    'C-Leg',
    'Genium',
    'Genium X3',
    'Gepardenknie',
    'Kenevo',
    'Kneuro',
    'Mauch Knie',
    'Mauch Knie Plus',
    'Paso Knie',
    'Rheo Knee XC',
    'Rheo Knie',
    'Total Knee 2000',
    'Total Knee 2100',
    'Totales Knie 1900',
    'Quadro',
    'Allux',
    'Genium X4',
    'Varia Flex',
    'Very Good',
    'Hytrek',
    'Locking Knee',
  ];

  mounted(): void {
    /*this.order.heightWithoutDeduction = 420;
    this.order.depth = 380;
    this.order.calfCircumferenceWithoutDeduction = 240;*/

    if (this.authentication.user) {
      this.automaticFit = false;
      CustomerService.getBodyAttributesByUserId(this.authentication.user.userId).then((bodyAttributes) => {
        this.bodyAttributes = bodyAttributes;
      });
    }
  }

  beforeMount() {
    if (!this.order.colorList) {
      this.order.colorList = [''];
    }

    const queryParams = new URLSearchParams(window.location.search);
    const supplier = queryParams.get('supplier');
    if (supplier) {
      this.showZipperOption = !this.hideZipperCompanyNames.includes(supplier);
    }
  }

  automaticFitChanged(): void {
    if (!this.automaticFit) this.selectedBodyAttribute = null;
  }
}
</script>

<style scoped lang="scss">
.el-form-item {
  margin-top: 0.5rem;
  font-weight: normal;
  color: #1d1e19;
}

:deep(.el-form-item__label) {
  color: #1d1e19;
}

.text-secondary {
  color: #0000008d !important;
  text-align: left !important;
}

.row1 {
  border-bottom: 0.1rem solid #6767678d;
}

.form-label {
  font-size: 1rem;
  margin: 0.7rem 0 0.5rem 0;
  text-align: right;
}

:deep(.custom-switch .el-switch__label) {
  color: white !important;
}

.el-slider {
  margin: 0.2rem;
  width: auto;
}

.el-input-number {
  width: 100%;
}

.info-button:hover {
  cursor: pointer;
  color: #565656;
}

.side-button-group {
  display: flex;
  gap: 0.5rem; /* space between buttons */
  justify-content: flex-start;
  flex-wrap: wrap; /* wrap on smaller screens */
}

/* Target the img inside the card */
:deep(.card img.side-image) {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

/* Optional: Adjust the card size from the parent */
:deep(.card) {
  width: 5.5rem !important;
  height: 9rem !important;
  padding: 0.0rem;
}
:deep(.card-title) {
  font-weight: 700;
  font-size: 12px;
}
</style>
